import { apiHelper } from '../../common/utils';
import mockHelper from '../../common/mockHelper';
import {localStore} from 'src-common/utils';

export const fetchFeeds = (data) => {
    // {
    //     "interact_data": {
    //       "influencer_id_list": [
    //         0
    //       ],
    //       "street_id_list": [
    //         0
    //       ],
    //       "product_id_list": [
    //         0
    //       ]
    //     },
    //     "page": 0,
    //     "page_size": 10,
    //     "uid": "wqeqwe"
    //   }
    let uid = localStore.getStore('uid');
    let fav = localStore.getStore('interact_data')
    for (let field in fav.interact_data) {
        fav.interact_data[field] = fav.interact_data[field].slice(-5, fav.interact_data[field].length)
    }
    localStore.setStore('interact_data', fav)
    data = {
        ...data,
        ...uid,
        ...fav
    }
    let options = {
        url: '/shop/web/lookbook',
        method: 'POST',
        data,
    }
    console.log(data)
    return apiHelper(options);
}

export const similarPeople = (params) => {
    let options = {
        url: '/shop/web/similar_icons',
        method: 'GET',
        headers: {'uid': -100},
        params,
    }
    let promise;
    if (process.env.REACT_APP_MOCK == 'MOCK2') {
        promise = mockHelper('personal_page2')
    } else {
        promise = apiHelper(options)
    }
    return promise;
}


// WEBPACK FOOTER //
// ./src/features/api/homePage.js